import { Text, VStack, HStack, Pressable } from "@gluestack-ui/themed";

import { Input } from "@repo/core/components/core/Input";

import { useDeviceType } from "@repo/core/hooks/useDeviceType";
import { DraftHeaderProps } from "./types";

import { useMemo, useState, useEffect } from "react";
import { useDimensions } from "@repo/core/hooks/useDimensions";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Icon } from "@repo/core/components/core/Icon";
import { useNavigation } from "@repo/core/hooks/useNavigation";

export const DraftHeader = ({
  onRefresh,
  lastUpdated,
  searchText,
  setSearchText
}: DraftHeaderProps) => {
  const [currentValue, setCurrentValue] = useState(searchText || "");
  const { back } = useNavigation();

  // Sync input value with searchText prop
  useEffect(() => {
    setCurrentValue(searchText || "");
  }, [searchText]);

  const { isTablet } = useDeviceType();
  const { isMobile } = useDimensions();

  const inputSearchRightIcon = {
    name: "magnifying-glass",
    onPress: () => {
      setSearchText(currentValue);
    }
  };

  const headerContentWidth = useMemo(() => {
    if (isTablet) return "80%";
    if (isMobile) return "$full";

    return "40%";
  }, [isMobile, isTablet]);

  return (
    <VStack
      width="$full"
      alignItems="center"
      justifyContent="center"
      py="$6"
      px="$4"
      bg="$primary700"
    >
      <VStack
        w={headerContentWidth}
        h="$fit-content"
        alignItems="center"
        justifyContent="center"
        gap="$4"
      >
        <HStack
          w="$full"
          minHeight="$8"
          alignItems="center"
          justifyContent="center"
          position="relative"
        >
          {isMobile ? (
            <Pressable
              position="absolute"
              left={0}
              w="$10"
              h="$10"
              alignItems="center"
              justifyContent="center"
              onPress={back}
              zIndex={1}
            >
              <Icon name="arrow-left" color="white" size={16} />
            </Pressable>
          ) : null}
          <HStack flex={1} alignItems="center" justifyContent="center">
            <Text color="$textLight50" fontWeight={500} fontSize="$lg">
              Rascunhos
            </Text>
          </HStack>
        </HStack>
        <HStack
          flex={1}
          alignItems="center"
          justifyContent="center"
          w="$full"
          // TODO: Add px="$8" when the API return the type of the proposal
          gap="$2"
        >
          <Input
            light
            width="$full"
            showClear
            name="search"
            value={currentValue}
            onClear={() => {
              setSearchText("");
              setCurrentValue("");
            }}
            onChange={(value) => {
              setCurrentValue(value);
              // Apply filter in real-time as user types
              setSearchText(value);
            }}
            onKeyPress={(e) => {
              // NOTE: When pressed Enter on web
              if (e.keyCode === 13) {
                setSearchText(currentValue);
              }
            }}
            onSubmitEditing={() => {
              // NOTE: When pressed Done/Finish on mobile
              setSearchText(currentValue);
            }}
            returnKeyType="done"
            rightIcon={inputSearchRightIcon}
            placeholder="Buscar proposta ou cliente"
          />
          {/*   <Button
            variant="outline"
            flex={1}
            borderColor="#FFFFFF50"
            $hover-backgroundColor="$primary800"
            $hover-BorderColor="$white"
            $focus-backgroundColor="$primary800"
            $focus-BorderColor="$white"
            $pressed-backgroundColor="$primary800"
            $pressed-BorderColor="$white"
            onPress={onFilterPress}
            w={isTablet ? "$fit-content" : "$12"}
            p="$1"
            h="$12"
          >
            {!isMobile ? (
              <Pressable onPress={onFilterPress} m="$0" p="$0">
                <ButtonIcon
                  name="filter"
                  size={filtersCount ? 22 : 18}
                  color="$white"
                  variant={filtersCount ? "solid" : "regular"}
                />
              </Pressable>
            ) : (
              <ButtonIcon
                name="filter"
                size={filtersCount ? 22 : 18}
                color="$white"
                variant={filtersCount ? "solid" : "regular"}
              />
            )}
            {filtersCount ? (
              <Badge
                alignItems="center"
                justifyContent="center"
                position="absolute"
                borderColor="$primary700"
                right={isTablet ? 16 : 6}
                bottom={8}
                bg="$white"
                px={5}
                rounded="$full"
                zIndex={1}
                size="sm"
                variant="solid"
              >
                <BadgeText color="$secondary800" fontSize={9}>
                  {filtersCount}
                </BadgeText>
              </Badge>
            ) : null}
          </Button> */}
        </HStack>
        <HStack alignItems="center" justifyContent="center" gap="$2">
          <Text fontSize="$2xs" color="$primary50" fontWeight={400}>
            {lastUpdated
              ? `Atualizado em ${format(lastUpdated, "dd/MM 'às' HH:mm:ss", {
                  locale: ptBR
                })}`
              : "Carregando..."}
          </Text>
          {onRefresh && (
            <Pressable onPress={onRefresh}>
              <Icon name="refresh" color="white" size={16} />
            </Pressable>
          )}
        </HStack>
      </VStack>
    </VStack>
  );
};
